module.exports = __webpack_public_path__ + "img/1.5b3ad063.png";